import { Component, Input } from "@angular/core";
import { Observable } from "rxjs";
import { AuthorService } from "src/app/inventory/author/author.service";
import { PublisherService } from "src/app/inventory/publisher/publisher.service";
import { SupplierService } from "src/app/inventory/supplier/supplier.service";
import { Page } from "src/app/util/page";
import { StringCriteriaSearchComponent } from "src/app/util/search/criteria/string-criteria-search.component";

@Component({
  selector: 'supplier-search-criteria',
  styleUrls: ['../../../../util/search/criteria/criteria-search.component.css'],
  templateUrl: '../../../../util/search/criteria/criteria-search.component.html'
})
export class SupplierSearchCriteriaComponent extends StringCriteriaSearchComponent {
  @Input()
  public loading = false;

  constructor(supplierService: SupplierService) {
    super("Fournisseur", query => supplierService.findNameLike(query));
  }

  formatResultsMetadataLabel(): string {
    return "fournisseur(s) affiché(s) sur";
  }
}